document.addEventListener('DOMContentLoaded', function () {
(function () {
  var overlay = document.getElementById('so-overlay');
  var backdrop = document.querySelector('.so-backdrop');
  if (!overlay || !backdrop) return;

  var input = document.getElementById('so-input');
  var closeBtn = document.getElementById('so-close');
  var defaultContent = document.getElementById('so-default');
  var resultsContent = document.getElementById('so-results');
  var resultsCount = resultsContent.querySelector('.so-results-count');
  var noResults = resultsContent.querySelector('.so-no-results');

  var debounceTimer = null;

  // SVG icons for list items
  var ICONS = {
    collection: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14l3 3 4-4"/></svg>',
    page: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>',
    article: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg>'
  };

  function openOverlay() {
    overlay.classList.add('is-open');
    backdrop.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 100);
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      input.value = '';
      showDefault();
    }, 300);
  }

  function showDefault() {
    defaultContent.hidden = false;
    resultsContent.hidden = true;
  }

  function showResults() {
    defaultContent.hidden = true;
    resultsContent.hidden = false;
  }

  function formatMoney(price) {
    var amount = parseFloat(price);
    if (isNaN(amount)) return '';
    return '$' + amount.toFixed(2).replace(/\.00$/, '');
  }

  function showSection(id, visible) {
    var el = document.getElementById(id);
    if (el) el.hidden = !visible;
  }

  function renderProducts(products) {
    var grid = document.getElementById('so-products-grid');
    grid.innerHTML = '';
    products.forEach(function (p) {
      var card = document.createElement('a');
      card.className = 'so-product-card';
      card.href = p.url;
      var imgWrap = document.createElement('div');
      imgWrap.className = 'so-product-card__img-wrap';
      if (p.featured_image && p.featured_image.url) {
        var img = document.createElement('img');
        img.src = p.featured_image.url;
        img.alt = p.featured_image.alt || p.title;
        img.loading = 'lazy';
        img.width = 400;
        img.height = 400;
        imgWrap.appendChild(img);
      }
      var title = document.createElement('div');
      title.className = 'so-product-card__title';
      title.textContent = p.title;
      var price = document.createElement('div');
      price.className = 'so-product-card__price';
      if (p.price) price.textContent = formatMoney(p.price);
      card.appendChild(imgWrap);
      card.appendChild(title);
      card.appendChild(price);
      grid.appendChild(card);
    });
  }

  function renderListItems(containerId, items, type) {
    var container = document.getElementById(containerId);
    container.innerHTML = '';
    items.forEach(function (item) {
      var a = document.createElement('a');
      a.className = 'so-list-item';
      a.href = item.url;

      var icon = document.createElement('div');
      icon.className = 'so-list-item__icon';
      icon.innerHTML = ICONS[type] || ICONS.page;

      var text = document.createElement('div');
      var titleEl = document.createElement('div');
      titleEl.className = 'so-list-item__title';
      titleEl.textContent = item.title;
      text.appendChild(titleEl);

      // Show blog name for articles
      if (type === 'article' && item.body_html) {
        var meta = document.createElement('div');
        meta.className = 'so-list-item__meta';
        meta.textContent = 'Article';
        text.appendChild(meta);
      }

      a.appendChild(icon);
      a.appendChild(text);
      container.appendChild(a);
    });
  }
  function filterProductsByTag(products, term) {
    return products.filter(function (p) {
      if (!p.tags) return false;

      return p.tags.some(function (tag) {
        return tag.toLowerCase().includes(term.toLowerCase());
      });
    });
  }
  function renderResults(data) {
    var productsRaw = (data.resources.results.products || []);
    var products = filterProductsByTag(productsRaw, input.value.trim());
    var collections = (data.resources.results.collections || []);
    var pages       = (data.resources.results.pages       || []);
    var articles = (data.resources.results.articles || []).filter(function (article) {
    return !(article.url && article.url.indexOf('/blogs/ingredients/') !== -1);
    });

    var total = products.length + collections.length + pages.length + articles.length;
    var term = input.value.trim();

    if (total === 0) {
      showSection('so-section-products', false);
      showSection('so-section-collections', false);
      showSection('so-section-pages', false);
      showSection('so-section-articles', false);
      noResults.hidden = false;
      resultsCount.textContent = '0 results';
      return;
    }

    noResults.hidden = true;
    resultsCount.textContent = total + (total === 1 ? ' result' : ' results') + ' for \u201c' + term + '\u201d';

    if (products.length) {
      renderProducts(products);
      showSection('so-section-products', true);
    } else {
      showSection('so-section-products', false);
    }

    if (collections.length) {
      renderListItems('so-collections-list', collections, 'collection');
      showSection('so-section-collections', true);
    } else {
      showSection('so-section-collections', false);
    }

    if (pages.length) {
      renderListItems('so-pages-list', pages, 'page');
      showSection('so-section-pages', true);
    } else {
      showSection('so-section-pages', false);
    }

    if (articles.length) {
      renderListItems('so-articles-list', articles, 'article');
      showSection('so-section-articles', true);
    } else {
      showSection('so-section-articles', false);
    }

    showResults();
  }

  function fetchResults(term) {
    // IMPORTANT: tag boosting query
    var tagQuery = `tag:${term}`;

    var url =
      '/search/suggest.json?q=' + encodeURIComponent(tagQuery) +
      '&resources[type]=product,collection,page,article' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderResults(data);
      })
      .catch(function () {
        noResults.hidden = false;
        resultsCount.textContent = '';
        showResults();
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var term = input.value.trim();
    if (!term) { showDefault(); return; }
    debounceTimer = setTimeout(function () {
      fetchResults(term);
    }, 280);
  });

  closeBtn.addEventListener('click', closeOverlay);
  backdrop.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeOverlay();
    }
  });

  overlay.querySelectorAll('.so-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var term = pill.getAttribute('data-term');
      input.value = term;
      fetchResults(term);
    });
  });

  ['search_toggle_desktop', 'search_toggle_mobile', 'search_mobile_toggle'].forEach(function (id) {
    var btn = document.getElementById(id);
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openOverlay();
      });
    }
  });

  window.openSearchOverlay = openOverlay;
  window.closeSearchOverlay = closeOverlay;
})();


});